export default function () {
  const accordions: NodeList | null = document.querySelectorAll(".accordion");
  if (accordions) {
    accordions.forEach((accordion: Node, i: number): void => {
      const _accordion = accordion as HTMLElement;
      const _accordionID: String = _accordion.id;
      const _accordionButton = document.querySelector(`[aria-controls="${_accordionID}"]`) as HTMLElement;
      _accordion.setAttribute("aria-hidden", "true");
      _accordion.setAttribute("hidden", "");
      toggleAccordion(_accordionButton, _accordion);
    });
  }

  function toggleAccordion(button: Element, accordion: Element): void {
    if (!button || !accordion) {
      return;
    }
    button.addEventListener("click", (e: Event): void => {
      e.preventDefault();
      const expanded = button.getAttribute("aria-expanded") === "true" || false;
      button.setAttribute("aria-expanded", String(!expanded));
      accordion.setAttribute("aria-hidden", String(expanded));
      accordion.toggleAttribute("hidden");
    });
  }

};
